import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { denyOrganization, isOrganizationDenied } from './denied-organizations'

const authHeader = 'Authorization'

export const errorInterceptor = () => {
  axios.interceptors.response.use(null, (error) => {
    const { response, config } = error
    if (!response) {
      // network error
      console.error(error)
      return
    }

    if (response.status === 401 && !config._retry) {
      const eventApis = ['api-v2/partners/events', '/api-v2/partners/events/configs', '/api-v2/timeline']

      if (eventApis.some(endpoint => config.url.includes(endpoint))) {
        // The organization the request was actually scoped to, which is not always the active one
        // by the time the response lands.
        const refusedOrganizationId = config.params?.organizationId ?? store.getters.getActiveOrganization?.id
        denyOrganization(refusedOrganizationId)

        const fallbackOrganization = store.getters.getUserOrganizations.find(org => !isOrganizationDenied(org.id))

        // Reload only when there is somewhere else to land. Reloading onto the organization that
        // was just refused reproduces this 401 on the next boot and loops forever -- which is what
        // the old fallback did, because it read `activeOrganizationId` off an organization (a field
        // organizations do not have), got undefined and switched to null every time.
        if (!fallbackOrganization || String(fallbackOrganization.id) === String(refusedOrganizationId)) {
          return Promise.reject(response)
        }

        return store.dispatch('setActiveOrganization', fallbackOrganization.id)
          .then(() => {
            return router.push({ name: "Home" }).then(() => {
              router.go(0)
              return Promise.reject(response)
            })
          })
      }
      config._retry = true

      if (store.getters.isLoggedIn && !config.headers[authHeader] && store.getters.authToken) {
        config.headers[authHeader] = `Bearer ${store.getters.authToken}`
        return axios(config)
      }

      if (response.data?.message?.includes("token is expired")) {
        const refreshConfig = axios.defaults
        refreshConfig._retry = true
        return store.dispatch('refresh', refreshConfig).then(() => {
          config.headers[authHeader] = `Bearer ${store.getters.authToken}`
          return axios(config)
        }, () => {
          return store.dispatch('logout').then(() => {
            router.push({ name: "Login" }).then(() => {
              return Promise.reject(response)
            })
          })
        })
      }

      // Logout fallback for other 401s
      if (config.url === '/api-v2/users') {
        store.dispatch('logout').then(() => {
          router.push({ name: "Login" }).then(() => {
            return Promise.reject(response)
          })
        })
      }
    }

    return Promise.reject(response)
  })
}
